import ProductCard from "../ui/ProductCard";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const featuredProducts = [
  {
    id: 1,
    category: "Coffee",
    name: "Morning Roast",
    price: 18,
    image: "/images/product1.jpg",
  },
  {
    id: 2,
    category: "Books",
    name: "The Kinfolk Table",
    price: 34,
    image: "/images/product2.jpg",
  },
  {
    id: 3,
    category: "Greens",
    name: "Monstera Deliciosa",
    price: 42,
    image: "/images/product3.jpg",
  },
];

export default function FeaturedCollection() {
  return (
    <section className="bg-gradient-to-b from-white to-[#F7F8F4] py-28">
    {/* <section className="bg-white py-28"> */}

      <div className="mx-auto max-w-7xl px-6">

        <div className="grid items-center gap-20 lg:grid-cols-2">

          {/* Left */}

          <div>

            <img
              src="/images/featured.jpg"
              alt=""
              className="rounded-3xl shadow-xl"
            />

          </div>

          {/* Right */}

          <div>

            <span className="uppercase tracking-[4px] text-[#6B8E5F] text-sm">

              Featured Collection

            </span>

            <h2 className="mt-5 text-5xl font-semibold leading-tight">

              Slow Mornings

              <br />

              Better Rituals

            </h2>

            <p className="mt-8 text-lg leading-8 text-gray-600">

              Every object tells a story.

              Discover our collection of carefully chosen books,
              freshly roasted coffee, handcrafted essentials,
              and living greens designed to inspire slower,
              more intentional living.

            </p>

            <Link
              to="/collections/slow-mornings"
              className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#6B8E5F] px-8 py-4 text-white transition hover:bg-[#557149]"
            >

              Explore Collection

              <ArrowRight size={18}/>

            </Link>

          </div>

        </div>

        {/* Products */}

        <div className="mt-24 grid gap-8 md:grid-cols-2 xl:grid-cols-3">

          {featuredProducts.map(product=>(
            <ProductCard
              key={product.id}
              {...product}
            />
          ))}

        </div>

      </div>

    </section>
  );
}